import { FiX, FiClipboard } from "react-icons/fi";

interface WorkoutPlanHeaderProps {
  initialData?: { id?: number } | null;
  onClose: () => void;
}

export const WorkoutPlanHeader = ({
  initialData,
  onClose,
}: WorkoutPlanHeaderProps) => {
  return (
    <div className="relative border-b border-stroke bg-gradient-to-r from-purple-50 via-purple-50 to-purple-50 px-3 py-3 sm:px-4 sm:py-4 md:px-8 md:py-6 dark:border-strokedark dark:from-purple-950/30 dark:via-purple-950/30 dark:to-purple-950/30">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      {/* Action Buttons - Mobile First */}
      <div className="absolute right-2 top-2 sm:right-3 sm:top-3 md:right-6 md:top-6 z-10 flex gap-1 sm:gap-1.5 md:gap-2">
        <button
          type="button"
          onClick={onClose}
          className="rounded-md sm:rounded-lg md:rounded-xl p-1.5 sm:p-2 md:p-2.5 text-gray-500 outline-none transition-all active:bg-white active:text-gray-700 active:scale-95 md:hover:bg-white md:hover:text-gray-700 md:hover:shadow-sm focus-visible:ring-2 focus-visible:ring-primary dark:text-gray-400 dark:active:bg-boxdark dark:active:text-gray-200 md:dark:hover:bg-boxdark md:dark:hover:text-gray-200 touch-manipulation"
          aria-label="Fechar"
        >
          <FiX size={18} className="sm:w-5 sm:h-5 md:w-6 md:h-6" />
        </button>
      </div>

      {/* Content - Mobile First */}
      <div className="relative flex items-start md:items-center gap-2 sm:gap-3 md:gap-4 pr-16 sm:pr-20 md:pr-0">
        {/* Icon Badge - Mobile First */}
        <div className="shrink-0 rounded-md sm:rounded-lg md:rounded-xl bg-gradient-to-br from-purple-600 to-purple-600 p-2 sm:p-2.5 md:p-3 text-white shadow-sm">
          <FiClipboard size={20} className="sm:w-6 sm:h-6 md:w-7 md:h-7" />
        </div>

        {/* Text Content */}
        <div className="min-w-0 flex-1">
          <h3 className="text-base sm:text-lg md:text-2xl font-bold text-gray-900 dark:text-white leading-tight">
            {initialData ? "Editar Plano de Treino" : "Novo Plano de Treino"}
          </h3>
          <p className="mt-0.5 sm:mt-0.5 md:mt-1 text-[11px] sm:text-xs md:text-sm text-gray-600 dark:text-gray-400 line-clamp-2 md:line-clamp-1">
            Configure exercícios, séries e cargas personalizadas
          </p>
        </div>
      </div>
    </div>
  );
};
